import script from "./MembershipManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./MembershipManagement.vue?vue&type=script&setup=true&lang=js"

import "./MembershipManagement.vue?vue&type=style&index=0&id=b3a6480c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3a6480c"]])

export default __exports__